import { useMemo, useRef } from "react";
import sanitize from "helpers/sanitize";
import usePlyr from "hooks/usePlyr";

export default function HtmlContent({ html, className = "", sanitizeOptions, ...rest }) {
  const ref = useRef(null);

  const sanitized = useMemo(() => {
    if (!html) return "";
    return sanitize(html, sanitizeOptions);
  }, [html, sanitizeOptions]);

  usePlyr(ref, [sanitized]);

  return <div ref={ref} className={className} dangerouslySetInnerHTML={{ __html: sanitized }} {...rest} />;
}
